import Home from './components/Home.vue'
import Budget from './components/budget/Budget.vue'
import Calendar from './components/calendar/Calendar.vue'
import Services from './components/Services.vue'
import Contacts from './components/contact/Contacts.vue'

export const routes = [
    {path: '/', component: Home},
    {path: '/services', component: Services,
        children: [
            {path: 'budget', component: Budget},
            {path: 'calendar', component: Calendar},
            {path: 'contacts', component: Contacts},
        ]
    }
];


// WEBPACK FOOTER //
// ./src/routes.js